export type Translation = {
    language: string;
    text: string;
};

export function sameTranslations(a: Translation[] = [], b: Translation[] = []): boolean {
    if (a.length !== b.length) return false;
    const byLanguage = new Map(b.map((translation) => [translation.language, translation.text]));
    return a.every((translation) => byLanguage.get(translation.language) === translation.text);
}

function canonicalize(value: unknown): unknown {
    if (value === null || typeof value !== "object") return value;
    if (Array.isArray(value)) return value.map(canonicalize);
    const obj = value as Record<string, unknown>;
    return Object.keys(obj)
        .sort()
        .reduce<Record<string, unknown>>((acc, key) => {
            acc[key] = canonicalize(obj[key]);
            return acc;
        }, {});
}

export function sameSource(a: unknown, b: unknown): boolean {
    return JSON.stringify(canonicalize(a)) === JSON.stringify(canonicalize(b));
}
